// extracted by mini-css-extract-plugin
export default {"form":"NovoDistribuidor_form__wbufL","areaBtn":"NovoDistribuidor_areaBtn__kYFRp","btn":"NovoDistribuidor_btn__dN8Sf"};